import { Box, Breadcrumbs, Button, Checkbox, Divider, FormControlLabel, FormGroup, Grid, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CommonLabel from '../Common/CommonLabel';
import CommonRadioButton from '../Common/CommonRadioButton';
import CommonTextField from '../Common/CommonTextField';
import CommonDatePicker from '../Common/CommonDatePicker';
import CommonCheckbox from '../Common/CommonCheckbox';
import CommonMultiSelectAutoComplete from '../Common/CommonMultiSelectAutoComplete';
import CommonFileUpload from '../Common/CommonFileUpload';
import { businessTypeOption, categoryNameOptions, rawMaterialOption, useCommonStyles } from '../../utils';
import CommonBox from '../Common/CommonBox';
import Assets from '../Common/Assets';
import SignatureCanvas from "react-signature-canvas";
import { addVendor, image, updateVendor } from '../../Redux/Actions/Vendor';
import { useDispatch } from 'react-redux';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import ErrorHandler from '../../lib/errorHandler';
import dayjs from 'dayjs';
import ErrorMessage from '../Common/ErrorMessage';
import { useAppSelector } from '../../Redux/app/hooks';
import localStoreUtil from '../../ApiSetUp/localstore.util';
import { isCompleteDate } from '../../lib/standardDateFormat';


const gstOptions = [
    { label: "GST No", id: 1 },
    { label: "N / A", id: 2 },
];

export const selectionCriteriaOptions = [
    { label: "On Basis of SCPL Past Experience", id: 1 },
    { label: "Sample Sent by Supplier", id: 2 },
    { label: "Any Other Reference", id: 3 },
];

const gradeDYesNoOption = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
];

const gradeDTypeOption = [
    { label: "Critical", value: "critical" },
    { label: "Non Critical", value: "nonCritical" },
];

const annexureAFilledOption = [
    { label: "Yes", value: true },
    { label: "No", value: false },
];

const AddNewVendor = ({ getInitialVendor, setIsOpenAddVendor, selectedVendorData, setSelectedVendorData, _getVendors, vendor, setVendor, sigCanvas, setSearchValue }) => {
    // =============== Hooks ===============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // =============== States ===============
    const [errors, setErrors] = useState({});
    const [bussinessTypeOption, setBussinessTypeOption] = useState(businessTypeOption);

    // =============== Handler ===============

    const loggedInUserDetails = localStoreUtil?.get_data("User_Data");
    const userData = loggedInUserDetails ? JSON.parse(loggedInUserDetails) : null;


    const clearSignature = () => {
        sigCanvas.current?.clear();
    };
    const handleChange = (name, value) => {
        if (name === "criteriaForSupplier") {
            setVendor((prevVendor) => {
                let updatedCriteria;
                if (!prevVendor.criteriaForSupplier) {
                    updatedCriteria = [value];
                } else if (prevVendor.criteriaForSupplier.includes(value)) {
                    updatedCriteria = prevVendor.criteriaForSupplier.filter(
                        (item) => item !== value
                    );
                } else {
                    updatedCriteria = [...prevVendor.criteriaForSupplier, value];
                }

                return {
                    ...prevVendor,
                    [name]: updatedCriteria,
                };
            });
        } else if (name == "getType") {
            setVendor({
                ...vendor,
                [name]: value,
                gstNumber: "",
                firstDoc: "",
                secondDoc: "",
            });
            setErrors({
                ...errors,
                [name]: "",
            });
        } else if (name == "selectionCriteria") {
            setVendor({
                ...vendor,
                [name]: value,
                "description": ""
            });
            setErrors({
                ...errors,
                [name]: "",
            });
        } else if (name == "annexure") {
            setVendor({
                ...vendor,
                [name]: value,
                checkbox_1: "",
                checkbox_2: "",
                checkbox_3: "",
                checkbox_4: "",
                checkbox_5: "",
                checkbox_6: "",
                checkbox_7: "",
                checkbox_8: "",
            });
            setErrors({
                ...errors,
                [name]: "",
            });
        } else if (name == "isGrade" && value == "no") {
            setVendor({
                ...vendor,
                [name]: value,
                gradeD: "nonCritical"
            });
            setErrors({
                ...errors,
                [name]: "",
            });
        }
        else {
            setVendor({
                ...vendor,
                [name]: value,
            });
            setErrors({
                ...errors,
                [name]: "",
            });
        }
    };
    const handleChangeVendorType = (event) => {
        const { name, checked } = event.target;

        setVendor((prevVendor) => {
            const updatedVendorType = checked
                ? [...(prevVendor.vendorType || []), name] // Add item if checked
                : (prevVendor.vendorType || []).filter((item) => item !== name); // Remove item if unchecked

            return {
                ...prevVendor,
                vendorType: updatedVendorType,
            };
        });
    };

    const mobileRegex = /^[0-9]{10}$/;
    const gstRegex = /^([0-9]{2})([A-Z]{5}[0-9]{4}[A-Z]{1})([A-Z\d]{1})([Z]{1})([A-Z\d]{1})$/;
    const isTraderOrManufactureSelected = vendor?.bussiness_type?.some(
        (selected) => selected.name === "Traders" || selected.name === "Manufacture"
    );

    const isServiceProviderSelected = vendor?.bussiness_type?.some(
        (selected) => selected.name === "Service Provider"
    );

    // =============== Validations ===============
    const validation = (isAdmin) => {
        let flag = true;
        let errors = {};
        if (isAdmin) {
            if (!vendor?.annexure) {
                flag = false;
                errors.annexure = "Please select annexure."
            }
        }

        if (vendor?.vendorType?.length == 0 || !vendor?.vendorType) {
            flag = false;
            errors.vendorType = "Please select vendor type."
        }
        if (!vendor.vendorId) {
            errors.vendorId = "Please enter Vendor Id.";
            flag = false;
        }
        if (!vendor.name) {
            errors.name = "Please enter name.";
            flag = false;
        }
        // if (!vendor.mobileNumber) {
        //     errors.mobileNumber = "Please enter mobile number.";
        //     flag = false;
        // }
        if (vendor?.mobileNumber && vendor?.mobileNumber?.length != 10) {
            errors.isValidMobileNo = "Please enter valid Phone No.";
            flag = false;
        }
        // if (!vendor.companyName) {
        //     errors.companyName = "Please enter company name.";
        //     flag = false;
        // }
        if (!vendor.rawMaterial || vendor.rawMaterial.length === 0) {
            errors.rawMaterial = "Please select a raw material.";
            flag = false;
        }
        if (!vendor.bussiness_type || vendor.bussiness_type.length === 0) {
            errors.bussiness_type = "Please select a business type.";
            flag = false;
        }
        if (isTraderOrManufactureSelected) {
            if (vendor?.selectionCriteria == 2) {
                if (!vendor.receivedDate) {
                    errors.receivedDate = "Please select sample received date.";
                    flag = false;
                }
                if (vendor.receivedDate) {
                    if (!isCompleteDate(vendor.receivedDate)) {
                        flag = false;
                        setSnackBar("error", "Please select valid received date")
                    }
                }
                if (!vendor.approvedDate) {
                    errors.approvedDate = "Please select sample approved date.";
                    flag = false;
                }
                if (vendor.approvedDate) {
                    if (!isCompleteDate(vendor.approvedDate)) {
                        flag = false;
                        setSnackBar("error", "Please select valid approved date")
                    }
                }
            }
        }
        if (vendor?.rawMaterial?.some((ele) => ele?.id == 6)) {
            if (!vendor?.otherName) {
                flag = false;
                errors.otherName = "Please enter other name.";
            }
        }
        // if (isServiceProviderSelected) {
        //     if (!vendor.scpl) {
        //         errors.scpl =
        //             "Please enter Visit of service provider at SCPL reference MOM.";
        //         flag = false;
        //     }
        // }
        // if (!vendor.address) {
        //     errors.address = "Please enter address.";
        //     flag = false;
        // }
        if (!vendor.getType) {
            errors.getType = "Please select type.";
            flag = false;
        }
        if (vendor.getType === "1" && !vendor.gstNumber) {
            errors.gstNumber = "Please enter GST number.";
            flag = false;
        } else if (
            vendor.getType === "1" &&
            vendor.gstNumber &&
            !gstRegex.test(vendor.gstNumber)
        ) {
            errors.gstNumber = "Please enter a valid GST number.";
            flag = false;
        }
        if (!vendor.gradeD) {
            errors.gradeD = "Please select gradeD type.";
            flag = false;
        }
        // if (!vendor.annexure) {
        //   errors.annexure = "please enter annexure.";
        //   flag = false;
        // }
        if (!vendor.selectionCriteria) {
            errors.selectionCriteria = "Please Select Criteria for Supplier.";
            flag = false;
        }
        if (vendor?.selectionCriteria == 3) {
            if (!vendor.description) {
                errors.description = "Please enter any other reference.";
                flag = false;
            }
        }
        // if (!vendor.approvalName) {
        //     errors.approvalName = "Please enter approval name.";
        //     flag = false;
        // }
        if (isAdmin) {
            if (vendor?.isBlackListed) {
                if (!vendor?.blackListDate) {
                    errors.blackListDate = "Please select blackList date.";
                    flag = false;
                }
                if (vendor?.blackListDate) {
                    if (!isCompleteDate(vendor?.blackListDate)) {
                        flag = false;
                        setSnackBar("error", "Please select valid blackList date")
                    }
                }
                if (vendor?.approvalDate) {
                    if (!isCompleteDate(vendor?.approvalDate)) {
                        flag = false;
                        setSnackBar("error", "Please select valid approval date")
                    }
                }
                if (!vendor?.remark) {
                    errors.remark = "Please enter remark.";
                    flag = false;
                }
            }
        }
        if (isAdmin) {
            if (vendor.annexure == 'true') {
                if (!vendor.checkbox_1) {
                    errors.checkbox_1 = "Please select vendor aware about ISO Standard 9001:2015";
                    flag = false;
                }
                if (!vendor.checkbox_2) {
                    errors.checkbox_2 = "Please select vendor aware about ISO Standard 14001:2015";
                    flag = false;
                }
                if (!vendor.checkbox_3) {
                    errors.checkbox_3 = "Please select vendor aware about ISO Standard 45001:2018";
                    flag = false;
                }
                if (!vendor.checkbox_4) {
                    errors.checkbox_4 = "Please select vendor maintaining quality plan";
                    flag = false;
                }
                if (!vendor.checkbox_5) {
                    errors.checkbox_5 = "Please select vendor have training program";
                    flag = false;
                }
                if (!vendor.checkbox_6) {
                    errors.checkbox_6 = "Please select vendor have health and safety program";
                    flag = false;
                }
                if (!vendor.checkbox_7) {
                    errors.checkbox_7 = "Please select non-conformance procedure";
                    flag = false;
                }
                if (!vendor.checkbox_8) {
                    errors.checkbox_8 = "Please select aterial Safety Data Sheets maintained";
                    flag = false;
                }
            }
        }

        setErrors(errors);
        return flag;
    };
    // ============= File Upload API =============
    const handleUploadImg = async (files, fieldName) => {
        setFullPageLoader(true);
        let response;
        const formData = new FormData();
        formData.append("image", files[0]);
        response = await dispatch(image(formData));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                const imageUrl = response?.payload?.data?.[0]?.image;
                if (imageUrl) {
                    setVendor((prev) => ({
                        ...prev,
                        [fieldName]: imageUrl,
                    }));
                    setErrors((prev) => ({
                        ...prev,
                        [fieldName]: "",
                    }));
                }
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };
    // ============= Add New Vendor API =============
    const _addVendor = async (isAdmin) => {
        if (validation(isAdmin)) {
            const businessTypeNames = vendor.bussiness_type.map((type) =>
                String(type.id)
            );
            const rawMaterialNames = vendor.rawMaterial.map((type) =>
                String(type.name)
            );
            setFullPageLoader(true);
            let response;
            let body = {
                "vendorType": vendor?.vendorType || null,
                "name": vendor?.name || null,
                "vendorCode": vendor?.vendorId || null,
                "mobileNumber": vendor?.mobileNumber || null,
                "personName": vendor?.companyName || null,
                "rawMaterial": rawMaterialNames || null,
                "address": vendor?.address || null,
                "isGstNo": vendor.getType == "1" ? true : false,
                "gstNumber": vendor?.gstNumber || null,
                "GSTDocument": vendor?.firstDoc ? String(vendor?.firstDoc) : null,
                "MSMEDocument": vendor?.secondDoc ? String(vendor?.secondDoc) : null,
                "bussiness_type": businessTypeNames || null,
                "gradeD": {
                    "isYes": String(vendor.isGrade),
                    "isCritical": String(vendor.gradeD),
                },
                "selectionCriteria": Number(vendor?.selectionCriteria),
                "receivedDate": vendor.receivedDate ? dayjs(vendor.receivedDate).format("YYYY-MM-DD") : null,
                "approvedDate": vendor.approvedDate ? dayjs(vendor.approvedDate).format("YYYY-MM-DD") : null,
                "description": vendor?.description || null,
                "approvalDetails": {
                    "approvalName": isAdmin ? (vendor?.approvalName || null) : null,
                    "approvalDate": isAdmin ? (vendor?.approvalDate ? dayjs(vendor?.approvalDate).format("YYYY-MM-DD") : null) : null,
                    "annexure": isAdmin ? (vendor?.annexure == "false" ? false : vendor?.annexure == "true" ? true : null) : null,
                    "signature": isAdmin ? (sigCanvas.current && !sigCanvas.current.isEmpty() ? sigCanvas.current.toDataURL("image/png").split(",")[1] : null) : null,
                    "checkbox_1": isAdmin ? (vendor?.checkbox_1 == "false" ? false : vendor?.checkbox_1 == "true" ? true : null) : null,
                    "checkbox_2": isAdmin ? (vendor?.checkbox_2 == "false" ? false : vendor?.checkbox_2 == "true" ? true : null) : null,
                    "checkbox_3": isAdmin ? (vendor?.checkbox_3 == "false" ? false : vendor?.checkbox_3 == "true" ? true : null) : null,
                    "checkbox_4": isAdmin ? (vendor?.checkbox_4 == "false" ? false : vendor?.checkbox_4 == "true" ? true : null) : null,
                    "checkbox_5": isAdmin ? (vendor?.checkbox_5 == "false" ? false : vendor?.checkbox_5 == "true" ? true : null) : null,
                    "checkbox_6": isAdmin ? (vendor?.checkbox_6 == "false" ? false : vendor?.checkbox_6 == "true" ? true : null) : null,
                    "checkbox_7": isAdmin ? (vendor?.checkbox_7 == "false" ? false : vendor?.checkbox_7 == "true" ? true : null) : null,
                    "checkbox_8": isAdmin ? (vendor?.checkbox_8 == "false" ? false : vendor?.checkbox_8 == "true" ? true : null) : null,
                },
                "otherName": vendor?.otherName || null,
                "isBlackListed": isAdmin ? (vendor?.isBlackListed ? true : false) : null,
                "blackListDate": isAdmin ? (vendor?.blackListDate ? dayjs(vendor?.blackListDate).format("YYYY-MM-DD") : null) : null,
                "remark": isAdmin ? (vendor?.remark || null) : null
            }
            if (selectedVendorData?._id) {
                body._id = selectedVendorData?._id
            }
            const fn = selectedVendorData?._id ? updateVendor : addVendor
            response = await dispatch(fn(body));
            let error = await ErrorHandler(response, setSnackBar);
            if (error) {
                if (response?.payload?.data) {
                    setSnackBar("success", response?.payload?.message);
                    setVendor(getInitialVendor())
                    setSelectedVendorData({})
                    setIsOpenAddVendor(false)
                    setSearchValue("")
                    _getVendors();
                }
                setFullPageLoader(false);
            }
            setFullPageLoader(false);
        }
    };
    // =============== Use Effects ===============

    useEffect(() => {
        if (!vendor?.rawMaterial?.some((ele) => ele?.id == 6)) {
            setVendor({
                ...vendor,
                "otherName": ""
            });
        }
    }, [vendor?.rawMaterial])

    useEffect(() => {
        const isTraderOrManufactureSelected = vendor?.bussiness_type?.some(
            (selected) =>
                selected.name === "Traders" || selected.name === "Manufacture"
        );

        const isServiceProviderSelected = vendor?.bussiness_type?.some(
            (selected) => selected.name === "Service Provider"
        );

        if (!isTraderOrManufactureSelected && !isServiceProviderSelected) {
            setBussinessTypeOption(businessTypeOption);
            return;
        }
        if (!isTraderOrManufactureSelected) {
            setVendor({ ...vendor, approvedDate: null, receivedDate: null })
        }

        if (isServiceProviderSelected) {
            setBussinessTypeOption(
                bussinessTypeOption?.filter((e) => e?.name === "Service Provider")
            );
        }

        if (isTraderOrManufactureSelected) {
            setBussinessTypeOption(
                bussinessTypeOption?.filter(
                    (e) => e.name === "Traders" || e.name === "Manufacture"
                )
            );
        }
    }, [vendor.bussiness_type]);

    const breadcrumbs = [
        <Typography color={theme.palette.bgBlack.main} sx={{ opacity: "70%", cursor: "pointer" }} fontFamily={'Satoshi-Medium'} onClick={() => { setIsOpenAddVendor(false); setVendor(getInitialVendor()); setSelectedVendorData({}); setSearchValue(""); _getVendors() }}>
            Vendor Management
        </Typography>,
        <Typography color={theme.palette.bgBlack.main} fontFamily={'Satoshi-Medium'}>
            {selectedVendorData?._id ? "Edit Vendor" : "Create New Vendor"}
        </Typography>,
    ];
    return (
        <Grid container spacing={4}>
            <Grid item xs={12}>
                <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>{selectedVendorData?._id ? "Edit Vendor" : "Add New Vender"}</Typography>
                <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                >
                    {breadcrumbs}
                </Breadcrumbs>
            </Grid>
            <Grid container item xs={12} md={userData?.role == "Admin" ? 7 : 12}>
                <CommonBox
                    buttons={true}
                    onHandleCancel={() => { setErrors({}); setVendor(getInitialVendor()); setIsOpenAddVendor(false); setSelectedVendorData({}) }}
                    onHandleSubmit={() => _addVendor()}
                    submitButtonName={"Save"}
                    RootBox={
                        <>
                            <Grid
                                container
                                spacing={2}
                                padding={{ xs: "0.5rem 1.5rem", sm: "1.5rem 2.5rem", md: "1.5rem 2.5rem", }}
                            >
                                <Grid item xs={12} display={"flex"} justifyContent={"start"} alignItems={"center"}>
                                    <Typography fontFamily={"Satoshi-Bold"} fontSize={"18px"}>Registration form</Typography>
                                    {/* <Box display={"flex"} gap={1}>
                                        <Button className={classes.cancelButton} startIcon={<Assets absolutePath={true} src={`/assets/img/Import.svg`} />}>Import</Button>
                                        <Button className={classes.cancelButton} onClick={() => setIsOpenAddVendor(true)} startIcon={<Assets absolutePath={true} src={`/assets/img/Local.svg`} />}>Add a local</Button>
                                    </Box> */}
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography fontSize={"14px"} fontWeight={500} fontFamily={"Satoshi-Medium"} color={"#2E2E30"}>Vendor Type <span style={{ color: theme.palette.error.main }}>*</span></Typography>
                                    <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={vendor?.vendorType?.includes("Local")}
                                                    onChange={handleChangeVendorType}
                                                    name="Local"
                                                />
                                            }
                                            label="Local"
                                            sx={{ "& .MuiFormControlLabel-label": { fontFamily: "Satoshi-Light" }, "& .MuiCheckbox-root": { padding: "4px 9px" } }}
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={vendor?.vendorType?.includes("Import")}
                                                    onChange={handleChangeVendorType}
                                                    name="Import"
                                                />
                                            }
                                            label="Import"
                                            sx={{ "& .MuiFormControlLabel-label": { fontFamily: "Satoshi-Light" }, "& .MuiCheckbox-root": { padding: "4px 9px" } }}
                                        />
                                    </FormGroup>
                                    <ErrorMessage text={(vendor?.vendorType?.length == 0 || !vendor?.vendorType) ? errors?.vendorType : ""} />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <CommonTextField
                                        label="Vendor Name"
                                        name="name"
                                        value={vendor.name}
                                        valid
                                        placeholder="Enter The Name"
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setVendor({
                                                ...vendor,
                                                name: value,
                                            });
                                            setErrors({
                                                ...errors,
                                                name: "",
                                            });
                                        }}
                                    />
                                    <ErrorMessage text={errors.name} />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <CommonTextField
                                        type={"number"}
                                        label="Vendor Code"
                                        name="vendorId"
                                        value={vendor.vendorId}
                                        valid
                                        placeholder="Enter The Code"
                                        onChange={(e) => handleChange("vendorId", e.target.value)}
                                    />
                                    <ErrorMessage text={errors.vendorId} />
                                </Grid>

                                <Grid item xs={12} sm={6} md={4}>
                                    <CommonTextField
                                        type="number"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        label="Phone Number"
                                        name="mobileNumber"
                                        value={vendor.mobileNumber}
                                        placeholder="Enter Your Number"
                                        onChange={(e) => {
                                            const { name, value } = e.target;
                                            if (/^\d*$/.test(e.target.value)) {
                                                if (+value <= 9999999999) {
                                                    handleChange("mobileNumber", e.target.value);
                                                }
                                            }
                                        }}
                                    />
                                    <ErrorMessage text={vendor?.mobileNumber && vendor?.mobileNumber?.length != 10 ? errors.isValidMobileNo : ""} />
                                </Grid>
                                <Grid item xs={12} sm={userData?.role == "Admin" ? 12 : 6} md={userData?.role == "Admin" ? 12 : 4}>
                                    <CommonTextField
                                        label="Person name"
                                        name="companyName"
                                        value={vendor.companyName}
                                        placeholder="Enter The Person name"
                                        onChange={(e) => handleChange("companyName", e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={userData?.role == "Admin" ? 12 : 6} md={userData?.role == "Admin" ? 12 : 4}>
                                    <CommonMultiSelectAutoComplete
                                        label={"Raw Material"}
                                        // options={rawMaterialOption}
                                        options={categoryNameOptions}
                                        value={vendor.rawMaterial}
                                        valid
                                        onChange={(e, newValue) =>
                                            handleChange("rawMaterial", newValue)
                                        }
                                        placeholder={"Select Raw Material"}
                                    />
                                    <ErrorMessage text={errors.rawMaterial} />
                                </Grid>
                                {vendor?.rawMaterial?.some((ele) => ele?.id == 6) &&
                                    <Grid item xs={12} sm={userData?.role == "Admin" ? 12 : 6} md={userData?.role == "Admin" ? 12 : 4}>
                                        <CommonTextField
                                            label="Other Name"
                                            valid
                                            name="otherName"
                                            placeholder="Enter Other Name"
                                            value={vendor.otherName || ""}
                                            onChange={(e) => handleChange("otherName", e.target.value)}
                                        />
                                        <ErrorMessage text={(vendor?.rawMaterial?.some((ele) => ele?.id == 6) && !vendor.otherName) ? errors.otherName : ""} />
                                    </Grid>
                                }
                                <Grid item xs={12} sm={userData?.role == "Admin" ? 12 : 6} md={userData?.role == "Admin" ? 12 : 4}>
                                    <CommonTextField
                                        label="Company Full Address"
                                        name="address"
                                        placeholder="Enter Your Address"
                                        value={vendor.address || ""}
                                        onChange={(e) => handleChange("address", e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CommonCheckbox
                                        text="Type"
                                        valid
                                        marginBottom={'0px'}
                                        flexDirection="row"
                                        checkLabels={gstOptions}
                                        color={"#000000"}
                                        name="getType"
                                        selectedValue={vendor.getType}
                                        handleChange={(e) => handleChange("getType", e.target.value)}
                                        isSingleSelection
                                    />
                                    <ErrorMessage text={errors.getType} />
                                </Grid>
                                {vendor.getType === "1" && (
                                    <>
                                        <Grid item xs={12}>
                                            <CommonTextField
                                                label="GST Number"
                                                name="gstNumber"
                                                placeholder="Eg: 22AAAAA0000A1Z5"
                                                value={vendor.gstNumber}
                                                onChange={(e) =>
                                                    handleChange("gstNumber", e.target.value)
                                                }
                                            />
                                            <ErrorMessage text={errors.gstNumber} />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <CommonLabel title={"Upload image"} subTitle={"(GST)"} />
                                            <CommonFileUpload
                                                value={vendor.firstDoc}
                                                setFieldValue={setVendor}
                                                handleImageChange={(files) => handleUploadImg(files, "firstDoc")}
                                                accept=".png,.jpeg,.jpg,.pdf,.xls,.xlsx"
                                                id="GST"
                                                handleSingleDelete={() => {
                                                    setVendor({
                                                        ...vendor,
                                                        firstDoc: "",
                                                    });
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <CommonLabel title={"Upload image"} subTitle={"(MSME)"} />
                                            <CommonFileUpload
                                                value={vendor.secondDoc}
                                                setFieldValue={setVendor}
                                                handleImageChange={(files) => handleUploadImg(files, "secondDoc")}
                                                accept=".png,.jpeg,.jpg,.pdf,.xls,.xlsx"
                                                id="MSME"
                                                handleSingleDelete={() => {
                                                    setVendor({
                                                        ...vendor,
                                                        secondDoc: "",
                                                    });
                                                }}
                                            />
                                        </Grid>
                                    </>
                                )}
                                <Grid item xs={12} sm={12} md={5} lg={6} xl={6}>
                                    <CommonMultiSelectAutoComplete
                                        label={"Select Business Type"}
                                        options={bussinessTypeOption}
                                        value={vendor.bussiness_type}
                                        valid
                                        onChange={(e, newValue) =>
                                            handleChange("bussiness_type", newValue)
                                        }
                                        placeholder={"Select Business Type"}
                                    />
                                    <ErrorMessage text={errors.bussiness_type} />
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography sx={{ fontFamily: "Satoshi-Medium", fontSize: "14px", mb: 1 }}> Grade D <span style={{ color: theme.palette.error.main }}>*</span></Typography>
                                    <Box
                                        sx={{
                                            alignItems: "baseline",
                                            display: "flex",
                                            "@media (max-width: 600px)": {
                                                display: "flex",
                                                flexDirection: "column",
                                            },
                                        }}
                                    >
                                        <CommonRadioButton
                                            radioLabels={gradeDYesNoOption}
                                            name="isGrade"
                                            selectedValue={vendor.isGrade}
                                            handleChange={(e) =>
                                                handleChange("isGrade", e.target.value)
                                            }
                                            dotColor={"#000000"}
                                        />
                                        <Divider
                                            orientation="vertical"
                                            sx={{
                                                height: "20px",
                                                mr: "16px",
                                                display: "block",
                                                "@media (max-width: 600px)": {
                                                    display: "none",
                                                },
                                            }}
                                        />
                                        <CommonRadioButton
                                            radioLabels={gradeDTypeOption}
                                            name="gradeD"
                                            selectedValue={vendor.gradeD}
                                            handleChange={(e) => handleChange("gradeD", e.target.value)}
                                        />
                                    </Box>
                                    <ErrorMessage text={errors.gradeD} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography fontSize={'16px'} fontFamily={"Satoshi-Bold"} >Selection Criteria for Supplier <span style={{ color: theme.palette.error.main }}>*</span></Typography>
                                    <CommonCheckbox
                                        checkLabels={selectionCriteriaOptions}
                                        name="selectionCriteria"
                                        selectedValue={vendor?.selectionCriteria}
                                        handleChange={(e) =>
                                            handleChange("selectionCriteria", e.target.value)
                                        }
                                    />
                                    <ErrorMessage text={!vendor?.selectionCriteria ? errors?.selectionCriteria : ""} />
                                </Grid>
                                {vendor?.selectionCriteria == 3 &&
                                    <Grid item xs={12}>
                                        <CommonTextField
                                            label={"Any Other Reference"}
                                            placeholder={"Additional comments or details..."}
                                            multiline={true}
                                            rows={4}
                                            valid
                                            name={"description"}
                                            value={vendor?.description}
                                            onChange={(e) => handleChange("description", e.target.value)}
                                        />
                                        <ErrorMessage text={(vendor?.selectionCriteria == 3 && !vendor?.description) ? errors?.description : ""} />
                                    </Grid>
                                }
                                {isTraderOrManufactureSelected && (
                                    <>
                                        <Grid item xs={12} sm={6} md={4} lg={4}>
                                            <CommonDatePicker
                                                valid={vendor?.selectionCriteria == 2 ? true : false}
                                                label={"Sample Received Date"}
                                                onChange={(value) => handleChange("receivedDate", value)}
                                                value={vendor?.receivedDate || null}
                                                name={"receivedDate"}
                                                maxDate={vendor?.approvedDate}
                                            />
                                            <ErrorMessage text={errors.receivedDate} />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4} lg={4}>
                                            <CommonDatePicker
                                                valid={vendor?.selectionCriteria == 2 ? true : false}
                                                label={"Sample Approved Date"}
                                                value={vendor?.approvedDate || null}
                                                onChange={(value) => handleChange("approvedDate", value)}
                                                name={"approvedDate"}
                                                minDate={vendor?.receivedDate}
                                            />
                                            <ErrorMessage text={errors.approvedDate} />
                                        </Grid>
                                    </>
                                )}

                            </Grid>
                        </>
                    }
                />
            </Grid>
            {userData?.role == "Admin" &&
                <Grid container item xs={12} md={5} height={"fit-content"}>
                    <CommonBox
                        buttons={true}
                        onHandleCancel={() => { setErrors({}); setVendor(getInitialVendor()); setIsOpenAddVendor(false); setSelectedVendorData({}) }}
                        onHandleSubmit={() => _addVendor(true)}
                        submitButtonName={"Save"}
                        RootBox={
                            <>
                                <Grid container spacing={2}
                                    padding={{ xs: "0.5rem 1.5rem", sm: "1.5rem 2.5rem", md: "1.5rem 2.5rem", }}>
                                    <Grid item xs={12}>
                                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"18px"}>Approval Details for Admin</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                        <CommonTextField
                                            label={"Name of Approver"}
                                            placeholder={"Enter your name"}
                                            name={"approvalName"}
                                            value={vendor?.approvalName}
                                            onChange={(e) => handleChange("approvalName", e.target.value)}
                                        />
                                        {/* <ErrorMessage text={errors.approvalName} /> */}
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}>
                                        <CommonLabel title={"Approval Date"} />
                                        <CommonDatePicker
                                            value={vendor?.approvalDate || null}
                                            onChange={(value) => handleChange("approvalDate", value)}
                                            name={"approvalDate"}
                                        />
                                        {/* <ErrorMessage text={errors.approvalDate} /> */}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CommonLabel title={"Annexure A Filled"} valid fontSize={"14px"} marginBottom={2} />
                                        <CommonRadioButton
                                            radioLabels={annexureAFilledOption}
                                            name="annexure"
                                            selectedValue={vendor.annexure}
                                            handleChange={(e) =>
                                                handleChange("annexure", e.target.value)
                                            }
                                        /><br />
                                        <ErrorMessage text={!vendor?.annexure ? errors.annexure : ""} />
                                    </Grid>
                                    {(vendor?.annexure == "true" || vendor?.annexure === true) &&
                                        <>
                                            <Grid item xs={12}>
                                                <CommonLabel valid title={"Is vendor aware about ISO Standard 9001:2015?"} fontSize={"14px"} marginBottom={2} />
                                                <CommonRadioButton
                                                    radioLabels={annexureAFilledOption}
                                                    name="checkbox_1"
                                                    selectedValue={vendor.checkbox_1}
                                                    handleChange={(e) =>
                                                        handleChange("checkbox_1", e.target.value)
                                                    }
                                                />
                                                <br />
                                                <ErrorMessage text={(vendor.annexure == 'true' && !vendor.checkbox_1) ? errors?.checkbox_1 : ""} />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <CommonLabel valid title={"Is vendor aware about ISO Standard 14001:2015?"} fontSize={"14px"} marginBottom={2} />
                                                <CommonRadioButton
                                                    radioLabels={annexureAFilledOption}
                                                    name="checkbox_2"
                                                    selectedValue={vendor.checkbox_2}
                                                    handleChange={(e) =>
                                                        handleChange("checkbox_2", e.target.value)
                                                    }
                                                />
                                                <br />
                                                <ErrorMessage text={(vendor.annexure == 'true' && !vendor.checkbox_2) ? errors?.checkbox_2 : ""} />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <CommonLabel valid title={"Is vendor aware about ISO Standard 45001:2018?"} fontSize={"14px"} marginBottom={2} />
                                                <CommonRadioButton
                                                    radioLabels={annexureAFilledOption}
                                                    name="checkbox_3"
                                                    selectedValue={vendor.checkbox_3}
                                                    handleChange={(e) =>
                                                        handleChange("checkbox_3", e.target.value)
                                                    }
                                                />
                                                <br />
                                                <ErrorMessage text={(vendor.annexure == 'true' && !vendor.checkbox_3) ? errors?.checkbox_3 : ""} />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <CommonLabel valid title={"Is vendor maintaining quality plan?"} fontSize={"14px"} marginBottom={2} />
                                                <CommonRadioButton
                                                    radioLabels={annexureAFilledOption}
                                                    name="checkbox_4"
                                                    selectedValue={vendor.checkbox_4}
                                                    handleChange={(e) =>
                                                        handleChange("checkbox_4", e.target.value)
                                                    }
                                                />
                                                <br />
                                                <ErrorMessage text={(vendor.annexure == 'true' && !vendor.checkbox_4) ? errors?.checkbox_4 : ""} />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <CommonLabel valid title={"Do vendor have training program?"} fontSize={"14px"} marginBottom={2} />
                                                <CommonRadioButton
                                                    radioLabels={annexureAFilledOption}
                                                    name="checkbox_5"
                                                    selectedValue={vendor.checkbox_5}
                                                    handleChange={(e) =>
                                                        handleChange("checkbox_5", e.target.value)
                                                    }
                                                />
                                                <br />
                                                <ErrorMessage text={(vendor.annexure == 'true' && !vendor.checkbox_5) ? errors?.checkbox_5 : ""} />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <CommonLabel valid title={"Do vendor have health and safety program?"} fontSize={"14px"} marginBottom={2} />
                                                <CommonRadioButton
                                                    radioLabels={annexureAFilledOption}
                                                    name="checkbox_6"
                                                    selectedValue={vendor.checkbox_6}
                                                    handleChange={(e) =>
                                                        handleChange("checkbox_6", e.target.value)
                                                    }
                                                />
                                                <br />
                                                <ErrorMessage text={(vendor.annexure == 'true' && !vendor.checkbox_6) ? errors?.checkbox_6 : ""} />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <CommonLabel valid title={"Is there a non-conformance procedure?"} fontSize={"14px"} marginBottom={2} />
                                                <CommonRadioButton
                                                    radioLabels={annexureAFilledOption}
                                                    name="checkbox_7"
                                                    selectedValue={vendor.checkbox_7}
                                                    handleChange={(e) =>
                                                        handleChange("checkbox_7", e.target.value)
                                                    }
                                                />
                                                <br />
                                                <ErrorMessage text={(vendor.annexure == 'true' && !vendor.checkbox_7) ? errors?.checkbox_7 : ""} />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <CommonLabel valid title={"Are material Safety Data Sheets maintained?"} fontSize={"14px"} marginBottom={2} />
                                                <CommonRadioButton
                                                    radioLabels={annexureAFilledOption}
                                                    name="checkbox_8"
                                                    selectedValue={vendor.checkbox_8}
                                                    handleChange={(e) =>
                                                        handleChange("checkbox_8", e.target.value)
                                                    }
                                                />
                                                <br />
                                                <ErrorMessage text={(vendor.annexure == 'true' && !vendor.checkbox_8) ? errors?.checkbox_8 : ""} />
                                            </Grid>
                                        </>}

                                    <Grid item xs={12}>
                                        <CommonLabel title={"Signature"} fontSize={"14px"} />
                                        <Box position={"relative"}>
                                            <Button onClick={clearSignature} sx={{ position: "absolute", right: "5px", top: "8px", borderRadius: "30px", padding: "3px", backgroundColor: "#D9D9D9", color: "#000", ":hover": { backgroundColor: '#D9D9D9' } }}>
                                                Clear
                                            </Button>
                                            <SignatureCanvas
                                                ref={sigCanvas}
                                                penColor="black"
                                                backgroundColor="#F6F6F699"
                                                canvasProps={{
                                                    style: { border: "1px solid #D0D0D0", width: "100%", height: "130px", borderRadius: "10px" },
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={vendor?.isBlackListed}
                                                        onChange={(e) => setVendor({ ...vendor, isBlackListed: e.target.checked, blackListDate: null, remark: "" })}
                                                        name="isBlackListed"
                                                    />
                                                }
                                                label="Vendor Blacklist"
                                                sx={{ "& .MuiFormControlLabel-label": { fontFamily: "Satoshi-Light" }, "& .MuiCheckbox-root": { padding: "4px 9px" } }}
                                            />
                                        </FormGroup>
                                    </Grid>
                                    {vendor?.isBlackListed &&
                                        <>
                                            <Grid item xs={12} sm={6} md={6}>
                                                <CommonDatePicker
                                                    valid
                                                    label={"blackList Date"}
                                                    value={vendor?.blackListDate || null}
                                                    onChange={(value) => handleChange("blackListDate", value)}
                                                    name={"blackListDate"}
                                                />
                                                <ErrorMessage text={(vendor?.isBlackListed && !vendor?.blackListDate) ? errors.blackListDate : ""} />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <CommonTextField
                                                    label={"Remarks"}
                                                    placeholder={"Remarks..."}
                                                    multiline={true}
                                                    rows={4}
                                                    valid
                                                    name={"remark"}
                                                    value={vendor?.remark}
                                                    onChange={(e) => handleChange("remark", e.target.value)}
                                                />
                                                <ErrorMessage text={(vendor?.isBlackListed && !vendor?.remark?.trim()) ? errors?.remark : ""} />
                                            </Grid>
                                        </>}
                                </Grid>
                            </>
                        }
                    />
                </Grid>
            }
        </Grid>
    )
}

export default AddNewVendor